import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import { useTheme } from 'next-themes';

import { ETheme } from '@/enums/theme';

import styles from './Qr.module.scss';

const handleDownloadEvent = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'App_click',
  });
};

const Qr = ({ data, className }) => {
  const { theme } = useTheme();

  const renderLinks = (item) => {
    return (
      <a
        className={styles['qr-link']}
        href={item.link}
        key={item?.id}
        target={`${data?.target}`}
        onClick={handleDownloadEvent}
        itemScope
        itemType='https://schema.org/LinkRщду'
      >
        <Image
          className={styles['qr-link__logo']}
          src={
            item?.dark_mode_image && theme === ETheme.DARK_MODE
              ? item?.dark_mode_image
              : item.image
          }
          alt='qr link logo'
          title='Qr Link Logo'
          width={148}
          height={48}
          loading='lazy'
        />
      </a>
    );
  };

  return (
    <section
      data-testid='qr-section'
      className={classNames(styles.qr, className)}
      itemScope
      itemType='https://schema.org/Property'
    >
      <div className={styles.qr__inner}>
        {!!data?.links && (
          <div className={styles.qr__links}>{data.links.map(renderLinks)}</div>
        )}
        {!!data?.qr && (
          <div className={styles['qr-item']}>
            <Image
              className={styles['qr-item__pic']}
              src={data.qr}
              alt={data.qr}
              width={168}
              height={168}
              loading='lazy'
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default Qr;
